import { RootState } from 'product-personalizer/src/store';

const getSelectedPreviewIndex = (state: RootState) => state.productPersonalizer.selectedPreviewIndex;

export default getSelectedPreviewIndex;
